export default {
  isAuthenticated: state => !!state.token,
  authUser: state => state.user || null,
  trainer: state => state.trainer || null,
  runner: state => state.runner || null,
  runnersTrainer: state => state.runnersTrainer || null,

  isAdmin: state => state.user && state.user.role_id === 'ADMIN',
  isTrainer: state => state.user && state.user.role_id === 'TRAINER',
  isRunner: state => state.user && state.user.role_id === 'RUNNER',
  isActiveRunnerTrainer: (state, getters) => {
    return getters.isAdmin || (getters.isTrainer && getters.runnersTrainer && getters.runnersTrainer.id === getters.authUser.id)
  },
  isActiveRunner: (state, getters) => {
    return getters.isRunner && getters.runner && getters.userLoaded && getters.runner.id === getters.authUser.id
  },
  userLoaded: state => state.user !== null,

  allPackagesOptions: state => {
    return state.initial.allPackages.map(x => {
      return {value: x.id, text: x.name}
    })
  },
  allPackagesFullOptions: state => {
    return state.initial.allPackages
  },
  getPackageById: (state) => (id) => {
    return state.initial.allPackages.find(packageData => packageData.id === id)
  },
  allTrainersOptions: state => {
    return state.initial.allTrainers.map(x => {
      return {value: x.id, text: x.full_name}
    })
  },
  allTrainersFullOptions: state => {
    return state.initial.allTrainers
  },
  trainerRunnersOptions: state => {
    return state.trainerRunners.map(x => {
      return {value: x.id, text: x.full_name}
    })
  },
  getTrainerById: (state) => (id) => {
    return state.initial.allTrainers.find(trainerData => trainerData.id === id)
  },
  raceFrequencyOptions: state => {
    return state.initial.raceFrequency
  },
  tshirtSizeOptions: state => {
    return state.initial.tshirtSize
  },
  allWorkoutsTemplatesOptions: state => {
    return state.initial.allWorkoutsTemplates.map(x => {
      return {value: x.name, text: x.name}
    })
  },
  getWorkoutTemplateByName: (state) => (name) => {
    return state.initial.allWorkoutsTemplates.find(workoutTemplateData => workoutTemplateData.name === name)
  },
  allRaceDistanceStringsOptions: state => {
    return state.initial.raceDistanceStrings
  },
  raceDistanceTrackStringsOptions: state => {
    return state.initial.raceDistanceTrackStrings
  },
  raceDistanceStreetStringsOptions: state => {
    return state.initial.raceDistanceStreetStrings
  },
  allRaceTypesStringsOptions: state => {
    return state.initial.raceTypesStrings
  },
  recordsRaceTypesStringsOptions: state => {
    return state.initial.recordsRaceTypesStrings
  },
  measurableRaceDistanceStringsOptions: state => {
    return state.initial.measurableRaceDistanceStrings
  },
  measurableRaceDistanceStreetStringsOptions: state => {
    return state.initial.measurableRaceDistanceStreetStrings
  },
  allRacePrioritiesOptions: state => {
    return state.initial.racePriorities.map(x => {
      return {value: x, text: x}
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js